module.exports = __webpack_public_path__ + "static/footer_left-4e6573e5dfa980c6c17e58f5c6013d8d.svg";